import styled from "styled-components";
import { device } from "./Device";
import turqRect from "../assets/images/turquioze-rectangle.png";
import blackRect from "../assets/images/black-rectangle.png";

export const MeetupBtn = styled.a`
  background-image: url(${blackRect});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;

  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  border: none;
  background-color: transparent;

  color: white;
  font-family: inherit;
  text-decoration: none;
  letter-spacing: 0.2vw;

  filter: drop-shadow(0 0.7vh 1vh rgba(0, 0, 0, 0.5));

  @media ${device.mobileS} {
    width: 35vw;
    height: 6vh;
    font-size: 1.8vh;
    padding-bottom: 0.5vh;
  }

  @media ${device.mobileM} {
    width: 22vh;
    height: 6vh;
    font-size: 1.8vh;
  }

  @media ${device.mobileL} {
    width: 21vh;
    height: 6vh;
    font-size: 1.8vh;
  }

  @media ${device.tablet} {
    width: 35vw;
    max-width: 20vw;
    height: 8vh;
    font-size: 2.5vh;
    padding-bottom: 1vh;
  }
`;

export const VisitUsBtn = styled.a`
  background-image: url(${turqRect});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;

  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  border: none;
  background-color: transparent;

  color: white;
  font-family: inherit;
  text-decoration: none;
  padding-bottom: 0.6vh;

  filter: drop-shadow(0 0.7vh 1vh rgba(0, 0, 0, 0.5));

  @media ${device.mobileS} {
    transform: scale(1);
    width: 33vw;
    height: 7vh;
    font-size: 2.2vh;
    margin-left: 0;
    align-self: center;

    transform: translateY(-12vh);
  }

  @media ${device.mobileM} {
    transform: scale(1);
    width: 33vw;
    height: 8vh;
    font-size: 2.5vh;
    margin-left: 0;
    align-self: center;

    transform: translateY(-11vh);
  }

  @media ${device.mobileL} {
    transform: scale(1);
    width: 35vw;
    height: 7.5vh;
    font-size: 2.3vh;
    margin-left: 0;
    align-self: center;

    transform: translateY(-14vh);
  }

  @media ${device.tablet} {
    transform: scale(1);
    width: 25vh;
    height: 8vh;
    font-size: 2.6vh;
    margin-left: 0;
    align-self: center;

    transform: translateY(-9vh);
  }

  @media ${device.laptop} {
    width: 25vw;
    height: 10vh;
    margin-left: -15vw;
    margin-top: 4vh;

    align-self: flex-start;
    cursor: pointer;
    font-size: 3.8vh;
    transform: translateY(0);

    &:hover {
      transform: scale(1.04);
      transition: transform 0.1s ease;
    }
  }

  @media ${device.laptopL} {
    width: 21vw;
    height: 10vh;
    margin-left: -25vw;
    margin-top: 10vh;

    align-self: flex-start;
    cursor: pointer;
    font-size: 3.6vh;

    &:hover {
      transform: scale(1.04);
      transition: transform 0.1s ease;
    }
  }

  @media ${device.desktop} {
    width: 20vw;
    height: 11vh;
    margin-left: -25vw;
    margin-top: 4vh;

    align-self: flex-start;
    cursor: pointer;
    font-size: 3.9vh;

    &:hover {
      transform: scale(1.04);
      transition: transform 0.1s ease;
    }
  }
`;
